import React from "react";

/* Stylised Zopran lightning bolt — matches the logo */
export default function Bolt({ size = 24, className = "", color = "currentColor", strokeWidth = 0, ...rest }) {
  return (
    <svg
      viewBox="0 0 100 160"
      width={size}
      height={size}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      {...rest}
    >
      <path
        d="M58 4 L20 84 L46 84 L36 156 L80 60 L52 60 L72 4 Z"
        fill={color}
        stroke={strokeWidth ? color : "none"}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
    </svg>
  );
}

/* Big watermark version positioned absolutely */
export function BoltWatermark({ className = "", color = "#5CE1E6", opacity = 0.08, rotate = -8, size = 360 }) {
  return (
    <Bolt
      size={size}
      color={color}
      className={`zp-bolt-bg ${className}`}
      style={{ opacity, transform: `rotate(${rotate}deg)` }}
    />
  );
}
